import { requests } from "../config";
import { BARKODE_TYPE, IResponseSrikaGo, IResponseSrikaNode } from "./models/srika";

export const Gathering = {
    gatheringStats: (dateStart: string, dateEnd: string) => 
        requests.get(`monitoring/gathering_stats?DateFrom=${dateStart}&DateTo=${dateEnd}`, 'go'),
    getKnisaByBarcode: (barcode: string | number, orderNum?: number): Promise<IResponseSrikaNode> => 
        requests.get(`likut/entry/${barcode}/${orderNum || 0}`, 'node'),
    getPermanentKnisaByBarcode: (barcode: string): Promise<IResponseSrikaGo> => 
        requests.get(`/barcode/${barcode}`, 'go'),
    getKnisot: (type: BARKODE_TYPE) => requests.get(`barcode?BarcodeType=${type}`, "go")
}